import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskNotificationsInternalNotificationsRoute: InvariantJiraRoute =
	{
		name: 'project-settings-servicedesk-notifications-internal-notifications',
		path: '/jira/servicedesk/projects/:projectKey/settings/notifications/internal-notifications',
	};
